import Vue from 'vue';

import router from '@/router';
import { auth, database } from '@/database';

export const reducer = state => ({
  ...state,
  initialized: false,
});

export const initialState = () => ({
  initialized: false,
  username: null,
  uid: null,
});

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    setUser(state, { username, uid }) {
      Vue.set(state, 'initialized', true);
      Vue.set(state, 'username', username);
      Vue.set(state, 'uid', uid);
    },
  },
  actions: {
    subscribe({ commit }) {
      auth.onAuthStateChanged(async (user) => {
        if (user == null) {
          commit('setUser', { username: null, uid: null });
          if (router.currentRoute.meta.requiresAuth) {
            await router.push({ name: 'home' });
          }
        } else {
          const { uid } = user;
          const snapshot = await database.ref(`players/${auth.currentUser.uid}`).once('value');
          const player = snapshot.val();
          let username = 'unknown';
          if (player != null && typeof player.username === 'string') {
            ({ username } = player);
          }
          commit('setUser', { username, uid });
          if (router.currentRoute.name === 'home') {
            await router.push({ name: 'games' });
          }
        }
      });
    },
    async loginAnonymous(context, { username }) {
      await auth.signInAnonymously();
      await database.ref(`players/${auth.currentUser.uid}`).set({
        username,
        lastAction: +new Date(),
      });
    },
    async logout() {
      await auth.signOut();
    },
  },
};
